import React from "react";
import "./Template_3.css";

const Template_3_TopHeader = () => {
  return (
    <div className="Template_3 top-header">
      <div className="Template_3 container">
        <div className="Template_3 top-header-content">
          <div className="Template_3 social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </div>
          <div className="Template_3 contact-info">
            <span>
              <i className="fas fa-phone"></i> +1 (555) 987-6543
            </span>
            <span>
              <i className="fas fa-envelope"></i> concierge@wanderlux.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template_3_TopHeader;
